module.exports = __webpack_public_path__ + "favicons__hca/favicons.webpackcruft";


//////////////////
// WEBPACK FOOTER
// ./client/src/site__hca/favicons/html_code.html
// module id = D:\a\1\s\node_modules\file-loader\dist\cjs.js??ref--1-0!D:\a\1\s\node_modules\extract-loader\lib\extractLoader.js!D:\a\1\s\node_modules\html-loader\index.js??ref--1-2!D:\a\1\s\client\src\site__hca\favicons\html_code.html
// module chunks = site__hca